module.exports = __webpack_public_path__ + "img/cheque.983cbd48.svg";